export default __webpack_public_path__ + "292f9d58698d6909bca32e6593ed89fc.svg";